"use strict";
var DESCRIPTORS = require("../internals/descriptors");
var defineBuiltInAccessor = require("../internals/define-built-in-accessor");
var regExpFlagsDetection = require("../internals/regexp-flags-detection");
var regExpFlagsGetterImplementation = require("../internals/regexp-flags");
if (DESCRIPTORS && !regExpFlagsDetection.correct) {
  defineBuiltInAccessor(RegExp.prototype, "flags", {
    configurable: true,
    get: regExpFlagsGetterImplementation
  });
  regExpFlagsDetection.correct = true;
}
